/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RequestLiteFreeApplyParam } from '../models/RequestLiteFreeApplyParam';
import type { RequestLitePaidApplyParam } from '../models/RequestLitePaidApplyParam';
import type { ResponseLitePaidApplyParam } from '../models/ResponseLitePaidApplyParam';
import { request as __request } from '../core/request';

export class LiteAppliesService {

    /**
     * 無料申込
     * @returns any Success
     * @throws ApiError
     */
    public static async postLiteAppliesService({
requestBody,
}: {
requestBody?: RequestLiteFreeApplyParam,
}): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/lites/frees`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * 有料申込情報取得
     * @returns ResponseLitePaidApplyParam Success
     * @throws ApiError
     */
    public static async getLiteAppliesService({
token,
}: {
/** ライト版トークン **/
token?: string,
}): Promise<ResponseLitePaidApplyParam> {
        const result = await __request({
            method: 'GET',
            path: `/api/lites/paids`,
            query: {
                'token': token,
            },
        });
        return result.body;
    }

    /**
     * 有料申込開始
     * @returns string Success
     * @throws ApiError
     */
    public static async postLiteAppliesService1({
token,
}: {
token?: string,
}): Promise<string> {
        const result = await __request({
            method: 'POST',
            path: `/api/lites/paids`,
            query: {
                'token': token,
            },
        });
        return result.body;
    }

    /**
     * 有料申込完了
     * @returns any Success
     * @throws ApiError
     */
    public static async putLiteAppliesService({
token,
requestBody,
}: {
token?: string,
requestBody?: RequestLitePaidApplyParam,
}): Promise<any> {
        const result = await __request({
            method: 'PUT',
            path: `/api/lites/paids`,
            query: {
                'token': token,
            },
            body: requestBody,
        });
        return result.body;
    }

}